/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

import { defineStore } from 'pinia'
import { TCompany } from '@/types/TCompany'

export const useCompanyStore = defineStore('company', {
    state: () => ({
        companies: [] as TCompany[],
        currentNotPersistent: null as null | TCompany
    }),
    getters: {
        current(): null | TCompany {
            if (! this.currentNotPersistent) {
                const data = localStorage.getItem('ig_company_state')
                this.currentNotPersistent = data ? JSON.parse(data) : null
            }

            return this.currentNotPersistent
        },
    },
    actions: {
        setCurrent(company: TCompany) {
            localStorage.setItem('ig_company_state', JSON.stringify(company))
            this.currentNotPersistent = company
        },
        setCompanies(companies: TCompany[]) {
            this.companies = companies
        }
    }
})